import React from "react";

const UsersView = React.lazy(() => import("./Users.view"));

const UsersLoadable = () => <UsersView />;

export default () => <UsersLoadable />;
